import React, { useState } from 'react';
import { Button, Grid, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import './ImageUpload.css';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setImageMeta, setImages } from '../redux/imageSlice';
import { API_URL } from '../config/endpoint';
import TGZFileSelection from './dialogs/TGZFileSelection';
import useSnackbar from './dialogs/Snackbar';


function ImageUpload({ setSelectedImage }) {
    const [SnackbarComponent, showSnackbar] = useSnackbar();
    const images = useSelector(state => state.images);
    const [loading, setLoading] = useState({});
    const [tgzSelection, setTGZSelection] = useState(false);
    const dispatch = useDispatch();

    const headings = [
        { label: "Spectralis High Res", id: "spectralis_high_res" },
        { label: "Annotated Spectralis", id: "annotated_spectralis" },
        { label: "Spectralis report", id: "spectralis_report" },
        { label: "MAIA TGZ File", id: "maia_tgz_file" }
    ];

    const upload_image_file = (file, file_type) => {
        setLoading(prev => ({ ...prev, [file_type]: true }));

        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', file_type);
        formData.append('id', images.uuid);

        axios.post(API_URL + "/upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            setLoading(prev => ({ ...prev, [file_type]: false }));

            if (file_type !== "maia_tgz_file") {
                dispatch(setImageMeta({
                    name: file_type, value: {
                        url: res.data.url, path: res.data.path
                    }
                }));
                if (file_type === "spectralis_high_res") {
                    dispatch(setImages({ 
                        name: 'selectedImage', value: res.data.url
                    }));
                }
            } else {
                dispatch(setImageMeta({
                    name: file_type, value: {
                        options: res.data.options,
                        zip_name : res.data.name
                    }
                }));
                setTGZSelection(true);
            }
        }).catch(err => {
            setLoading(prev => ({ ...prev, [file_type]: false }));
            console.log(err);
            showSnackbar(err?.response?.data, "error")
            dispatch(setImages({
                name: file_type, value: {
                    file: null, path: null, url: null
                }
            }));
        });
    };

    const handleUpload = (event, file_id) => {
        if (event.target.files && event.target.files[0]) {
            if (file_id !== "maia_tgz_file") {
                let reader = new FileReader();
                reader.onload = (e) => {
                    dispatch(setImages({
                        name: file_id, value: {
                            file: e.target.result, path: null, url: null
                        }
                    }));
                };
                reader.readAsDataURL(event.target.files[0]);
            }
            upload_image_file(event.target.files[0], file_id);
        }
    };

    const handleImageClick = (index) => {
        setSelectedImage(images[index]);
    };

    const handleRemove = (file_id) => {
        dispatch(setImages({
            name: file_id, value: {
                file: null, path: null, url: null
            }
        }));
    };

    return (
        <Grid container justifyContent="center" spacing={2}>
            <SnackbarComponent />
            {headings.map((image_tag, index) => (
                <Grid item xs={6} key={index} className="imageContainer">
                    <div className="imageHeading">{headings[index].label}</div>
                    <div className="uploadWrapper">
                        {loading[image_tag.id] ? (
                            <div className="loadingOverlay">
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                                {images[image_tag.id].file || images[image_tag.id].url ? (
                                    <>
                                        <img
                                            src={images[image_tag.id].url || images[image_tag.id].file}
                                            alt={`file ${headings[image_tag.id]}`}
                                            onClick={() => handleImageClick(image_tag.id)}
                                            className="imagePreview"
                                        />
                                        <CloseIcon className="removeButton" onClick={() => handleRemove(image_tag.id)} />
                                    </>
                                ) : (
                                    <label htmlFor={`upload-button-file-${image_tag.id}`} className="uploadLabel">
                                        <Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
                                            +
                                        </Button>
                                        <input
                                            className="uploadInput"
                                            name={image_tag.id}
                                            id={`upload-button-file-${image_tag.id}`}
                                            type="file"
                                            onChange={(event) => handleUpload(event, image_tag.id)}
                                        />
                                    </label>
                                )}
                            </>
                        )}
                    </div>
                </Grid>
            ))}
            <TGZFileSelection onClose={() => setTGZSelection(false)} open={tgzSelection} />
        </Grid>
    );
}

export default ImageUpload;
